const eventClickInterest = (params: any, title?: any) => {
  let typeWeb = params?.category?.type;
  let titleArticle = `article_${title?.replace(/ /g, '_').toLowerCase()}`;
  if (typeof window !== 'undefined' && params) {
    (window as any).dataLayer.push({
      event: `generalEvent`,
      eventName: `${typeWeb === 'news' ? titleArticle : 'promo_saya_tertarik'}_button`,
      eventCategory: `${typeWeb === 'news' ? 'article' : typeWeb} page events`,
      eventAction: `click on ${typeWeb === 'news' ? title?.toLowerCase() : 'saya tertarik'}`,
      eventLabel: `${params?.contentCategory?.name?.toLowerCase()} - ${
        params?.titlePage?.toLowerCase() || 'Tidak Tersedia'
      }`,
    });
  }
};
export default eventClickInterest;
